import Vue from 'vue';
const AVAILABLE_VARIANTS = ['square', 'wide'];
export default Vue.extend({
    name: 'CardImage',
    props: {
        variant: {
            type: String,
            validator: v => AVAILABLE_VARIANTS.includes(v),
            default: 'square'
        }
    },
    computed: {
        cardImgClasses() {
            return {
                'c-card__img': this.variant === 'square',
                'c-card__img--wide': this.variant === 'wide',
            };
        }
    }
});
